import { PersonPinSharp } from "@mui/icons-material";
import styled from "styled-components";

export const ContainerInputBorderFull = styled.div<{ isMobile?: boolean }>`
  display: flex;
  flex-direction: column;
`;

export const InputBorderFull = styled.input<{
  isMobile?: boolean;
  isValid?: boolean;
}>`
  width: ${(props) => (props.isMobile ? "95%" : "476px")};
  position: relative;
  height: 30px;
  border-radius: 8px;
  padding: 10px 30px 10px 14px;
  font-size: 18px;
  border: ${(props) =>
    props.isValid ? "1px solid #D0D5DD" : "1px solid #FDA29B"};
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  font-family: "Inter", sans-serif;
  color: #101828;
  bottom: 10px;

  &:focus {
    outline: none;
  }
`;

export const InputBoderFullObrigatory = styled.span<{ isMandatory?: boolean }>`
  color: ${(props) => (props.isMandatory ? "#FDA29B" : "")};
`;

export const HelpOutline = styled.svg<{}> `
  position: relative;
  right: 100px;
`;